import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class MotivazioneStore {
  motivazione: string;

  constructor() {}

  public setMotivazione(motivazione: string) {
    console.log("[MotivazioneStore][setMotivazione]", motivazione);
    this.motivazione = motivazione;
  }

  public getMotivazione(): string {
    console.log("[MotivazioneStore][getMotivazione]", this.motivazione);
    return this.motivazione;
  }

  public resetMotivazione() {
    console.log("[MotivazioneStore][resetMotivazione]");
    this.motivazione = null;
  }
}
